import React from 'react';

const Heading = ({ 
  level = 1, 
  children, 
  className = '', 
  showInterLine = false,
  ...props 
}) => {
  const baseClasses = 'font-sans text-neutral-900 leading-tight';
  
  const levelClasses = {
    1: 'text-heading-1 font-medium',     // Responsive heading-1
    2: 'text-heading-2 font-medium',     // Responsive heading-2
    3: 'text-heading-3 font-medium',     // Responsive heading-3
    4: 'text-heading-4 font-medium',     // Responsive heading-4
    5: 'text-base font-medium',
    6: 'text-sm font-medium'
  };

  const interLineClasses = showInterLine && level <= 3 
    ? 'relative after:block after:hairline-b after:my-6 after:w-full' 
    : '';

  const Component = `h${level}`;
  const classes = `${baseClasses} ${levelClasses[level]} ${interLineClasses} ${className}`;

  return (
    <Component className={classes} {...props}>
      {children}
    </Component>
  );
};

export default Heading; 